import React, { Component } from 'react';
import PropTypes from 'prop-types';

import IOSInstallDialog from "./IOSInstallDialog";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";
import Constants from '../utils/Constants';
import NavigationHeader from './NavigationHeader';
import Banner from './Banner';
import Snackbar from './Snackbar';
//import SignalsNudgeBanner from "./SignalsNudgeBanner";
import LoadingIndicator from "../components/LoadingIndicator";

import {
	withStyles,
	withTheme,
	Button
} from '@material-ui/core';

const styles = theme => ({
	fullscreen: {
		// Found headerbar flexing based on media query - this mimics it so our content is always spaced ok
		//marginTop: theme.content.top,
		paddingTop: theme.content.top,

		[theme.breakpoints.down('sm')]: {
			//marginTop: theme.content["@media (max-width: 767px)"].top
			paddingTop: theme.content["@media (max-width: 991px)"].top
		},

		[theme.breakpoints.down('xs')]: {
			//marginTop: theme.content["@media (max-width: 767px)"].top
			paddingTop: theme.content["@media (max-width: 767px)"].top
		}
	},

	unauthenticated :{
		// paddingTop: theme.spacing(6.5)
	},

	fullScreenWithNudgeBanner: {
		[theme.breakpoints.up('sm')]: {
			paddingTop: theme.spacing(21.625)
		}
	},

	accessibilityBtn: {
		zIndex: 0,
		left: -100000,
		position: "fixed"
	},

	visibleAccessibilityBtn: {
		zIndex: 5000,
		left: theme.spacing(2)
	},

	skipNavBtn: {
		top: theme.spacing(7)
	},

	contrastBtn: {
		minWidth: 136,
		top: theme.spacing(12)
	},

	fabMoveUp: {
		[theme.breakpoints.down('md')]: {
			transform: 'translate3d(0, -46px, 0) !important',
			transition: `${theme.transitions.create('transform', {
				duration: theme.transitions.duration.enteringScreen,
				easing: theme.transitions.easing.easeOut,
			})} !important`,
		}
	},

	fabMoveUpMore: {
		[theme.breakpoints.down('md')]: {
			transform: 'translate3d(0, -69px, 0) !important',
			transition: `${theme.transitions.create('transform', {
				duration: theme.transitions.duration.enteringScreen,
				easing: theme.transitions.easing.easeOut,
			})} !important`,
		},

		[theme.breakpoints.down('sm')]: {
			transform: 'translate3d(0, -75px, 0) !important',
			transition: `${theme.transitions.create('transform', {
				duration: theme.transitions.duration.enteringScreen,
				easing: theme.transitions.easing.easeOut,
			})} !important`,
		},

		[theme.breakpoints.up('xs')]: {
			transform: 'translate3d(0, -90px, 0) !important',
			transition: `${theme.transitions.create('transform', {
				duration: theme.transitions.duration.enteringScreen,
				easing: theme.transitions.easing.easeOut,
			})} !important`,
		}
	},

	fabMoveDown: {
		[theme.breakpoints.down('md')]: {
			transform: 'translate3d(0, 0, 0) !important',
			transition: `${theme.transitions.create('transform', {
				duration: theme.transitions.duration.leavingScreen,
				easing: theme.transitions.easing.sharp,
			})} !important`,
		}
	},

	loadingIndicator: {
		marginTop: theme.spacing(25)
	}
});

class FullScreen extends Component {
	constructor(props, context) {
		super(props, context);

		//this.useSignalsBannerRef = React.createRef();
		this.backToNextRef = React.createRef();

		this.localStorageKey = Constants.LOCAL_STORAGE.CONTRAST;
		this.state = {
			className: "",
			showAccessibilityBtns: false,
			moreContrast: JSON.parse(localStorage.getItem(this.localStorageKey))
		};

		this.toggleAccessibilityBtns = this.toggleAccessibilityBtns.bind(this);
		this.toggleContrast = this.toggleContrast.bind(this);
		this.setClassName = this.setClassName.bind(this);
	}

	toggleAccessibilityBtns() {
		this.setState({showAccessibilityBtns: !this.state.showAccessibilityBtns});
	}

	toggleContrast() {
		localStorage.setItem(this.localStorageKey, !this.state.moreContrast);
		setTimeout(() => window.location.reload(), 100);
	}

	setClassName(className) {
		this.setState({className: className});
	}

	render() {
		// ************************************************************************************
		//	DON'T MOVE SKIP NAV BUTTON - needed for proper tabbing on faux page navigation
		// ************************************************************************************
		return (
			<AuthorizedUserContext.Consumer>
				{authenticatedUser => {
					let {showAccessibilityBtns, moreContrast, className} = this.state,
						{theme, classes, showIOSInstallDlg, iOSDlgCloseHandler,
							snackbarOpen, tallSnackbar, snackbarMessage, snackbarDuration,
							snackbarHandleEntering, snackbarHandleExited, snackbarHandleClick, snackbarHandleClose, snackbarAction,
							banner, hideHeaderbar, hideMargin, snackbarRef, locationPath,
							bannerClassName, bannerRef, bannerHandleEntering, bannerHandleEntered, bannerHandleExiting, bannerHandleExited,
							showUseSignalsBanner, showBackToBanner, signalsNudgeBannerExited, signalsNudgeExited,
							children, location, ...rest} = this.props,
						lessOrMore = moreContrast ? "Less" : "More",
						hasNudgeBanner = false,
						newChildren = React.Children.map(children, child =>
							React.cloneElement(child, {hasNudgeBanner: hasNudgeBanner ? true : false, setFullScreenClassName: this.setClassName})
						),
						
						hideLoadingIndicator = [`^/login$`, `^/signup$`, `^/reset-password/[a-zA-Z0-9]+$`];
						/*,
						signalsNudgeBanner = (
							<SignalsNudgeBanner
								hasNudgeBanner={hasNudgeBanner}
								showUseSignals={showUseSignalsBanner}
								showBackTo={showBackToBanner}
								useSignalsRef={this.useSignalsBannerRef}
								backToRef={this.backToNextRef}
								backToHandler={backToNext}
								signalsHandler={useSignals}
								shouldShowUseSignalsBanner={shouldShowUseSignalsBanner}
								shouldShowBackBanner={shouldShowBackBanner} />
						);*/

					return (
						<React.Fragment>
							{/*{signalsNudgeBanner}*/}
							<div className={`${!authenticatedUser ? classes.unauthenticated : hideMargin ? null : classes.fullscreen}
								${hasNudgeBanner ? classes.fullScreenWithNudgeBanner : ""} ${className}`}>
								{/* TODO: move this above banners for accessibility? */}
								{locationPath !== "/login" ? (
									<React.Fragment>
										<Button
											tabIndex="1"
											color="primary"
											variant="contained"
											href="#content_top"
											onFocus={this.toggleAccessibilityBtns}
											className={`${classes.skipNavBtn} ${classes.accessibilityBtn} ${showAccessibilityBtns ? classes.visibleAccessibilityBtn : null}`}>
											Skip Navigation
										</Button>
										<Button
											tabIndex="2"
											component="a"
											color="primary"
											variant="contained"
											onClick={this.toggleContrast}
											onBlur={this.toggleAccessibilityBtns}
											className={`${classes.contrastBtn} ${classes.accessibilityBtn} ${showAccessibilityBtns ? classes.visibleAccessibilityBtn : null}`}>
											{lessOrMore} Contrast
										</Button>
									</React.Fragment>
								) : null}
								{!hideHeaderbar ?
									<NavigationHeader
										{...rest}
										//signalsNudgeBanner={signalsNudgeBanner}
										hasSignalsBanner={false
											/*shouldShowUseSignalsBanner && showUseSignalsBanner ||
											shouldShowBackBanner && showBackToBanner
											// || !signalsNudgeBannerExited*/
										}
									/> : null
								}
								<Banner
									show={!!banner}
									icon={banner ? banner.icon : null}
									content={banner ? banner.content : null}
									actions={banner ? banner.actions : null}
									className={bannerClassName}
									bannerRef={bannerRef}
									onEntering={bannerHandleEntering}
									onEntered={bannerHandleEntered}
									onExiting={bannerHandleExiting}
									onExited={bannerHandleExited} />
								<main id="content_top">
									{/*this.props.children*/}
									{newChildren}
								</main>
								<Snackbar
									snackbarRef={snackbarRef}
									open={snackbarOpen}
									key={snackbarMessage}
									action={snackbarAction}
									message={snackbarMessage}
									autoHideDuration={snackbarDuration}
									onEntering={snackbarHandleEntering}
									onExited={snackbarHandleExited}
									onClose={snackbarHandleClose}
									onClick={snackbarHandleClose}
									anchorOrigin={{ vertical: 'bottom', horizontal: 'left'}} />
								<IOSInstallDialog
									showIOSInstallDlg={showIOSInstallDlg}
									iOSDlgCloseHandler={iOSDlgCloseHandler} />
							</div>
							{authenticatedUser || hideLoadingIndicator.find(path => location.pathname.match(new RegExp(`(${path})`, "i"))) ?
								null : <LoadingIndicator color={theme.palette.secondary.orange} className={classes.loadingIndicator} />
							}
						</React.Fragment>
					);
				}}
			</AuthorizedUserContext.Consumer>
		);
	}
}

FullScreen.propTypes = {
	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	csm: PropTypes.object.isRequired,
	children: PropTypes.object,
	signInUrl: PropTypes.string,
	title: PropTypes.string,
	hideHeaderbar: PropTypes.bool,
	hideMargin: PropTypes.bool,
	installable: PropTypes.bool,
	showIOSInstallDlg: PropTypes.bool,
	iOSDlgCloseHandler: PropTypes.func,
	handleInstallBtn: PropTypes.func,
	snackbarRef: PropTypes.object,
	showSnackbar: PropTypes.func,
	snackbarOpen: PropTypes.bool,
	tallSnackbar: PropTypes.bool,
	snackbarAction: PropTypes.object,
	snackbarMessage: PropTypes.string,
	snackbarDuration: PropTypes.number,
	snackbarHandleEntering: PropTypes.func,
	snackbarHandleExited: PropTypes.func,
	snackbarHandleClick: PropTypes.func,
	snackbarHandleClose: PropTypes.func,
	history: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
	locationPath: PropTypes.string.isRequired,
	banner: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	bannerRef: PropTypes.object,
	bannerHeight: PropTypes.number,
	bannerHandleEntering: PropTypes.func,
	bannerHandleEntered: PropTypes.func,
	bannerHandleExiting: PropTypes.func,
	bannerHandleExited: PropTypes.func,
	bannerClassName: PropTypes.string,
	showUseSignalsBanner: PropTypes.bool,
	showBackToBanner: PropTypes.bool,
	signalsNudgeExited: PropTypes.func,
	signalsNudgeBannerExited: PropTypes.bool,
	unauthenticated: PropTypes.bool
};

export default withStyles(styles)(withTheme(FullScreen));
